'use strict';

wbApp.directive('wbTeachersSelect', ['$timeout', '$translate', 'employeeSvc',
    function ($timeout, $translate, employeeSvc) {
        function formatResult(employee) {
            if (!employee) { return; }
            if (employee.isDeleted) {
                return employee.fullName + ' (' + $translate.instant('TXT_VAL_DELETED') + ')';
            } else if (!employee.active) {
                return employee.fullName + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')';
            } else {
                return employee.fullName;
            }
        }

        function formatSelection(employee) {
            if (employee.isDeleted) {
                return employee.fullName + ' (' + $translate.instant('TXT_VAL_DELETED') + ')';
            } else if (!employee.active) {
                return employee.fullName + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')';
            } else {
                return employee.fullName;
            }
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            scope: {
                employeeId: '='
            },
            link: function (scope, elm, attrs, ctrl) {
                let employees = [];
                let data = [];
                $timeout(function () {
                    employees = employeeSvc.getAllActiveAsync(ctrl.$modelValue);
                    
    
                    employees.$promise.then(function () {
                        let newData = employees.map(function (employee) {
                            return {
                                employeeID: employee.employeeID,
                                fullName: employee.fullName,
                                active: employee.active,
                                isDeleted: employee.isDeleted,
                                data: employee,
                                disabled: employee.employeeID === scope.employeeId,
                                locked: employee.employeeID === scope.employeeId
                            }
                        });
                        data.length = 0;
                        data.push.apply(data, newData);

                        $(elm).select2({
                            formatResult: formatResult,
                            formatSelection: formatSelection,
                            dropdownAutoWidth: true,
                            allowClear: false,
                            minimumResultsForSearch: -1,
                            id: function (model) { return model.employeeID; },
                            data: data,
                            multiple: true,
                            matcher: function (term, text, employee) {
                                return employee.fullName.toUpperCase().indexOf(term.toUpperCase()) >= 0;
                            }
                        });

                        ctrl.$render();
                    });
                });

                //format text from the user (view to model)
                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return scope.employeeId || '';
                    } else {
                        let employeeId = parseInt(scope.employeeId || '0');
                        if (Array.isArray(viewValue)) {
                            let result = _.map(viewValue, function (n) {
                                return parseInt(n);
                            });
                           
                            result = result.filter(function (id) {
                                return id !== employeeId;
                            });
                            result = [employeeId, ...result];
                           
                            result = result.join();
                            return result;
                        } else {
                            let result = _.map((viewValue.toString()).split(','), function (n) {
                                return parseInt(n);
                            });
                            
                            result = result.filter(function (id) {
                                return id !== scope.employeeId;
                            });
                            result = [employeeId, ...result];
                            
                            result = result.join();
                            return result;
                        }
                    }
                });

                //format text going to user (model to view)
                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return [];
                    } else {
                        let employeeId = parseInt(scope.employeeId || '0');
                        if (Array.isArray(value)) {
                            let result = _.map(value, function (n) {
                                return parseInt(n);
                            });
                            
                            result = result.filter(function (id) {
                                return id !== employeeId;
                            });
                            
                            return result;
                        } else {
                            let result = _.map(value.split(','), function (n) {
                                return parseInt(n);
                            });
                            
                            result = result.filter(function (id) {
                                return id !== employeeId;
                            });
                            
                            return result;
                        }
                    }
                });

                scope.$watch('employeeId', function (newValue, oldValue) {

                    if (!newValue) {
                        return;
                    }
                    
                    let oldEmployeeId = parseInt(oldValue || scope.employeeId || '0');
                    let employeeId = parseInt(newValue || scope.employeeId || '0');

                    employees.$promise.then(function () {
                        let newData = employees.map(function (employee) {
                            return {
                                employeeID: parseInt(employee.employeeID),
                                fullName: employee.fullName,
                                active: employee.active,
                                isDeleted: employee.isDeleted,
                                data: employee,
                                disabled: employee.employeeID === scope.employeeId,
                                locked: employee.employeeID === scope.employeeId
                            }
                        });

                        data.length = 0;
                        data.push.apply(data, newData);

                        let currentValue = ctrl.$modelValue || [];
                        
                        if (Array.isArray(currentValue)) {
                            currentValue = currentValue.filter(function (id) {
                                let parsedId = parseInt(id);
                                return parsedId !== employeeId && parsedId !== oldEmployeeId;
                            });
                        } else {
                            currentValue = _.map((currentValue.toString()).split(','), function (n) {
                                return parseInt(n);
                            });
                            currentValue = currentValue.filter(function (id) {
                                return id !== employeeId && id !== oldEmployeeId;
                            });
                        }

                        let valueWithEmployeeId = [employeeId, ...currentValue];
                        ctrl.$setViewValue(valueWithEmployeeId);
                        $(elm).select2('val', currentValue);
                    });
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });
            }
        }
    }]);